import { render, staticRenderFns } from "./GotedoProgressLoader.vue?vue&type=template&id=7bfb56cc&scoped=true"
import script from "./GotedoProgressLoader.vue?vue&type=script&lang=js"
export * from "./GotedoProgressLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb56cc",
  null
  
)

export default component.exports